import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './lib/auth';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import NewOrder from './pages/NewOrder';
import Orders from './pages/Orders';
import { CustomerList, CustomerDetail } from './pages/Customers';
import Banks from './pages/Banks';
import Reconcile from './pages/Reconcile';
import Expenses from './pages/Expenses';
import Employees from './pages/Employees';
import Advances from './pages/Advances';
import Report from './pages/Report';
import RatePage from './pages/Rate';
import Settings from './pages/Settings';
import AuditLog from './pages/AuditLog';
import Telegram from './pages/Telegram';
import MySalary from './pages/MySalary';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<Login />} />

          {/* All authenticated users */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/new-order" element={<NewOrder />} />
            <Route path="/orders" element={<Orders />} />
            <Route path="/customers" element={<CustomerList />} />
            <Route path="/customers/:email" element={<CustomerDetail />} />
            <Route path="/my-salary" element={<MySalary />} />
            <Route path="/settings" element={<Settings />} />
          </Route>

          {/* Manager + Admin */}
          <Route element={<ProtectedRoute managerOrAdmin />}>
            <Route path="/audit" element={<AuditLog />} />
          </Route>

          {/* Admin only */}
          <Route element={<ProtectedRoute adminOnly />}>
            <Route path="/banks" element={<Banks />} />
            <Route path="/reconcile" element={<Reconcile />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/employees" element={<Employees />} />
            <Route path="/advances" element={<Advances />} />
            <Route path="/report" element={<Report />} />
            <Route path="/rate" element={<RatePage />} />
            <Route path="/telegram" element={<Telegram />} />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
